import { render, staticRenderFns } from "./IntelligentManage.vue?vue&type=template&id=073a2e81&scoped=true"
import script from "./IntelligentManage.vue?vue&type=script&lang=js"
export * from "./IntelligentManage.vue?vue&type=script&lang=js"
import style0 from "./IntelligentManage.vue?vue&type=style&index=0&id=073a2e81&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073a2e81",
  null
  
)

export default component.exports